export default __webpack_public_path__ + "static/p4-f50462fe0efef64ae327bbb3d378a068.jpg";